export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9212.8692efe3.jpg";